var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPfeilRechts = function SvgPfeilRechts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-label": "Nach rechts",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.65 9.15-6.583-6.583a1.207 1.207 0 0 0-1.7 0 1.207 1.207 0 0 0 0 1.7L15.9 8.8H1.208A1.21 1.21 0 0 0 0 10c0 .667.542 1.208 1.208 1.208h14.684l-4.534 4.533a1.207 1.207 0 0 0 0 1.7c.234.234.542.35.85.35s.617-.116.85-.35l6.584-6.583a1.207 1.207 0 0 0 0-1.7z"
  })));
};
export default SvgPfeilRechts;